module.exports = __webpack_public_path__ + "static/media/ycmsydl.c8e58972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/ycmsydl.png
// module id = 450
// module chunks = 0